import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images//sus3.png'
import image2 from '../../images/sus1.png'
import image3 from '../../images/Netzence.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/image 139.png'
function BlogPost7() {

     const blogs = [
    {
      id: 1,
      badge: "Sustainable Farming",
      badgeColor: "#006633",
      title: "Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems",
      description: "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...",
      source: "05/02/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Global Footprint Network",
      badgeColor: "#006633",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "The United Nations welcomes Netzence Sustainability Limited into the United Nations Global Compact.",
      description: "Netzence Sustainability Limited is proud to announce its official acceptance as a participant in the United Nations Global Compact...",
      source: "18/07/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>The United Nations welcomes Netzence Sustainability Limited into the United Nations Global Compact.</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img src={netzence} alt="netzence" className='w-[48px]' loading="lazy"></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
            December 28, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
8 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img src={sportlight} alt="spotlight" className='object-fill w-[1200px]' loading="lazy"></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Netzence Sustainability Limited is proud to announce its official acceptance as a participant in the United Nations Global Compact, the world’s largest corporate sustainability initiative.</p>
      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
This milestone affirms our commitment to align our operations and strategies with the ten principles of the UN Global Compact in the areas of human rights, labour, environment, and anti-corruption. As part of a global network of over 20,000 companies and 2,000 non-business participants, Netzence will collaborate with other like-minded organizations to accelerate progress on the UN Sustainable Development Goals (SDGs).</p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Our participation in the UN Global Compact reinforces our dedication to driving positive change in Nigeria and across Africa. We are excited to collaborate with like-minded organizations, share best practices, and accelerate progress towards the Sustainable Development Goals.</p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
As a testament to its global impact, the United Nations Global Compact (UNGC) counts many of the world’s most respected companies among its participants. Netzence joins notable members include Unilever, Coca-Cola, Nestlé, Microsoft, Siemens, Johnson & Johnson, L’Oréal, Bayer, 3M, Deloitte, BMW, Nike, Procter & Gamble, PepsiCo, Volkswagen, Accenture, H&M, Shell, Ford, Danone, Chevron, Adidas, Oracle, KPMG, Ericsson, and General Electric, among others.</p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
The Compact has played a key role in uniting the private sector at major global forums like the United Nations Climate Change Conference (COP28), launching initiatives such as the Climate Ambition Accelerator – engaging over 2,600 companies from 80 countries – Sand advancing gender equality, water stewardship, and climate action through regional and sectoral platforms. These collective efforts have helped businesses worldwide set and achieve ambitious sustainability targets, access climate finance, and drive measurable progress toward the UN Sustainable Development Goals</p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Methane is not an abstract problem. Nigeria is Africa’s largest oil and gas producer and one of the world’s top ten countries in terms of gas flaring. Each year, billions of cubic metres of gas are burned off in open flares across the Niger Delta. These flames release not only carbon dioxide but also massive quantities of methane that slip undetected into the atmosphere. A national methane baseline study would provide scientific benchmarks for how much methane Nigeria emits and from which sectors. It would allow the country to participate in emerging methane-specific carbon markets — which often trade at a premium — and it would open the door to clean-tech investments in leak-detection systems, flare-capture projects, and waste-to-energy innovations. Perhaps most importantly, it would strengthen Nigeria’s hand in global climate negotiations, where methane reduction is now a central agenda item under the Global Methane Pledge.  
Through our flagship platform CloseCarbon, we are already advancing environmental accountability via blockchain-based carbon tracking and verified emissions reductions. Now, as a UNGC participant, Netzence will continue to innovate and lead in the areas of climate action, clean technology, and ethical business.</p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
We look forward to contributing to the Global Compact’s mission and advancing sustainability in every aspect of our work.</p>
      {/* Paragraph 8 */}
     
      {/* Paragraph 12 */}

    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost7